import {Component, ElementRef, inject, OnInit} from '@angular/core';
import {MastersResultsService} from "../service/MastersResults.service";
import {fadeInAnimation} from "../animations/fadeInAnimation";


@Component({
    selector: 'app-master-results',
    templateUrl: './master-results.component.html',
    styleUrls: ['./master-results.component.css'],
    animations: [fadeInAnimation],
    host: {'[@fadeInAnimation]': ''}
})
export class MasterResultsComponent implements OnInit {
    elRef = inject(ElementRef);

    public masterResultsService = inject(MastersResultsService);


    ngOnInit() {
        this.restartMasterTable();
        this.getMasterResultHeaders();
        this.masterResultsService.getAllMasterResults();
    }

    getMasterResultHeaders() {
        this.masterResultsService.getAllTableHeaderNames();
    }

    openMasterDetailsItem(id: number) {
        this.masterResultsService.openMasterDetailsItem(id)
    }

    refreshTable() {
        this.masterResultsService.onRefreshTable();
    }

    restartMasterTable() {
        this.masterResultsService.restartTableValue();
    }

    deleteMasterRecord(id: number, tableName: string) {
        this.masterResultsService.deleteMasterRecord(id, tableName)
    }

    changeMasterSortDirection($event: any) {
        const tableElement = this.elRef.nativeElement.querySelector(".table-container");
        this.masterResultsService.changeSortDirection($event.valueOf(), tableElement);
    }

    formatDate(value: any, column: string): string {
        if (value == null || value === '') return '-';

        const dateColumns = ['date', 'dateUploaded', 'dateUpdated', 'dateExported', 'dateMatched', 'versionDateUploaded', 'dateuploaded'];
        if (dateColumns.includes(column)) {
            const parts = value.toString().split('-');
            if (parts.length < 6) return value;

            let year, month, day, hours, minutes, seconds;

            if (parseInt(parts[0], 10) > 12) {
                day = parseInt(parts[0], 10);
                month = parseInt(parts[1], 10) - 1;
                year = parseInt(parts[2], 10);
            } else if (parseInt(parts[1], 10) > 12) {
                month = parseInt(parts[0], 10) - 1;
                day = parseInt(parts[1], 10);
                year = parseInt(parts[2], 10);
            } else {
                if (column === 'dateuploaded') {
                    month = parseInt(parts[0], 10) - 1;
                    day = parseInt(parts[1], 10);
                } else {
                    day = parseInt(parts[0], 10);
                    month = parseInt(parts[1], 10) - 1;
                }
                year = parseInt(parts[2], 10);
            }

            hours = parseInt(parts[3], 10);
            minutes = parseInt(parts[4], 10);
            seconds = parseInt(parts[5], 10);

            const utcDate = new Date(Date.UTC(year, month, day, hours, minutes, seconds));

            if (isNaN(utcDate.getTime())) return value;

            const localDay = utcDate.getDate().toString().padStart(2, '0');
            const localMonth = (utcDate.getMonth() + 1).toString().padStart(2, '0');
            const localYear = utcDate.getFullYear();
            const localHours = utcDate.getHours().toString().padStart(2, '0');
            const localMinutes = utcDate.getMinutes().toString().padStart(2, '0');
            const localSeconds = utcDate.getSeconds().toString().padStart(2, '0');

            return `${localDay}-${localMonth}-${localYear} ${localHours}:${localMinutes}:${localSeconds}`;
        }

        return value;
    }
}
